import { CheckIcon } from '@icons/CheckIcon';
import { WarningIcon } from '@icons/WarningIcon';
import { type ReactNode, useState } from 'react';
import {
  CheckIconSpan,
  Container,
  ErrorMessage,
  FormLabel,
  Input,
  MainLabel,
  WarningIconSpan,
} from '../../../styles';
import type { IDateInput } from '../../types';
import { getLabel } from './helper';
import { isValidDateFormat } from 'service/date/isValidDateFormat';

export const DateInput = ({
  field,
  formikProps,
  count,
}: {
  field: IDateInput;
  formikProps: any;
  count: number;
}): ReactNode => {
  const [fieldChanged, setFieldChanged] = useState(true);

  const error = formikProps.errors[field.fieldName];
  const hasError = error || (field.required && !formikProps.values[field.fieldName] && count > 1);
  const fieldValue = formikProps.values[field.fieldName];
  const displayValue =
    fieldChanged && isValidDateFormat(fieldValue) ? formikProps.values[field.fieldName] : '';
  const hasValue = !!formikProps.values[field.fieldName];

  const handleChange = (e: any) => {
    setFieldChanged(true);
    formikProps.handleChange(e);
  };
  return (
    <Container className={field?.hidden ? 'hidden' : ''} aria-hidden={!!field?.hidden}>
      <MainLabel>
        <FormLabel tag="span" type="lead" className="text-gray-500">
          {getLabel(field)}
        </FormLabel>
        <Input
          type="date"
          name={field.fieldName}
          onChange={handleChange}
          value={displayValue}
          data-test={`text-${field.fieldName}`}
          $hasError={!!error}
          aria-required={!!field.required}
        />
        {!hasError && hasValue && (
          <CheckIconSpan $isDate>
            <CheckIcon />
          </CheckIconSpan>
        )}
        {hasError && (
          <WarningIconSpan $isDate>
            <WarningIcon />
          </WarningIconSpan>
        )}
      </MainLabel>
      {hasError && (
        <ErrorMessage data-test={`text-${field.fieldName}-error`}>* {error}</ErrorMessage>
      )}
    </Container>
  );
};
